import React from "react";
import { PageHeader, ToolTiles, Section } from "@/components/dashboard/DashboardPrimitives";
import ReportsPanel from "@/components/dashboard/ReportsPanel";
import ParentQuizCard from "@/components/dashboard/ParentQuizCard";

export default function DoctorDashboard({ user }) {
  return (
    <>
      <PageHeader user={user} subtitle="Clinical workspace — run analyses, review reports, add clinical notes." />

      <ToolTiles />

      <Section title="Patients shared with me" description="Parents will soon be able to share individual reports with you." testid="doctor-shared-section">
        <div className="rounded-xl bg-[#0E1A3A] border border-slate-800 p-6 text-sm text-slate-400">
          Report-sharing is coming soon. For now, analyses you run on this account appear below.
        </div>
      </Section>

      <ParentQuizCard />

      <Section title="My reports" description="Every analysis you run is saved here." testid="doctor-reports-section">
        <ReportsPanel userRole={user.role} />
      </Section>
    </>
  );
}
